var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spacing-container"},[_c('Letter',{attrs:{"items":_vm.letterSpacing}}),_c('LineSpacing',{attrs:{"items":_vm.lineSpacing}}),_c('Column')],1)}
var staticRenderFns = []

export { render, staticRenderFns }